var React = require('react');

function ArrowThin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.1511 24C11.7657 24 11.3803 23.8525 11.0867 23.5589L0.441161 12.9148C0.155111 12.6288 -0.00296881 12.2403 4.22381e-05 11.8369C0.00455882 11.4319 0.170167 11.0465 0.459228 10.7664L11.162 0.421957C11.7612 -0.154659 12.7142 -0.138098 13.2908 0.45809C13.8689 1.05578 13.8524 2.00878 13.2547 2.5869L3.65245 11.867L13.2156 21.4301C13.8042 22.0187 13.8042 22.9702 13.2156 23.5589C12.922 23.8525 12.5366 24 12.1511 24Z","fill":"#FAAE17"}));
}

ArrowThin.defaultProps = {"width":"14","height":"24","viewBox":"0 0 14 24","fill":"none"};

module.exports = ArrowThin;

ArrowThin.default = ArrowThin;
